/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { CHANGE_SPONSOR } from '../../config/constants';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class ChangeSponsorConfimationModalContext {
  public isFrom!: string;
  public data?: any;
}

@Component({
  selector: 'change-sponsor-confimation-modal',
  templateUrl: './change-sponsor-confirmation-modal.component.html',
  styleUrls: ['./change-sponsor.component.scss'],
  providers: [CommonService],
  encapsulation: ViewEncapsulation.None
})
export class ChangeSponsorConfimationModalComponent implements OnInit {
  @Input() context!: ChangeSponsorConfimationModalContext;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  public param: any;
  public currentSponsor: any;
  public newSponsor: any;
  public genTypes: any = {};

  constructor(
    public bsModalRef: BsModalRef<ChangeSponsorConfimationModalContext>,
    public commonService: CommonService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const vm = this;
    this.param = {
      value: this.context.data.type
    };
    this.currentSponsor = this.context.data.currentSponsor;
    this.newSponsor = this.context.data.newSponsor;
    vm.genTypes[CHANGE_SPONSOR.participant] = this.getTranslationWithKey('salesforce_only');
    vm.genTypes[CHANGE_SPONSOR.personalGroup] = this.getTranslationWithKey('salesforce_and_personal');
    vm.genTypes[CHANGE_SPONSOR.downlineLeg] = this.getTranslationWithKey('salesforce_and_downline');
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeModalWindow() {
    this.closeModal.emit('closed');
    this.bsModalRef.hide();
  }

  public confirmChange() {
    this.closeModal.emit('confirmed');
    this.bsModalRef.hide();
  }
}
